module.exports = __webpack_public_path__ + "media/huoma.bce0111b.mp4";